module.exports = __webpack_public_path__ + "img/bank-save-transaction-disabled.26aa1d8b.svg";